module.exports = __webpack_public_path__ + "static/media/1500.494abfd6.jpg";